import { storefrontAll } from '@graphcommerce/next-ui'

export const storeCodes = storefrontAll.map((i) => i.magentoStoreCode)

export const baseUrl = import.meta.graphCommerce.canonicalBaseUrl
